import React from 'react'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import Button from '@nobia/zeus-components/lib/buttons'
import { Container, Row, Column } from '@nobia/zeus-components/lib/grid'
import { SubHeadline } from '@nobia/zeus-components/lib/text'
import { cdnImage } from '../../utils'

const image = cdnImage(require('../../assets/close.svg'))

const Modal = styled.div`
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
`

const ModalDialog = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
`

const ModalContent = styled.div`
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  min-height: 100vh;
  height: 100%;
  border-radius: 0;
`

const ModalHeader = styled.div`
  display: block;
  padding: 15px;
  text-align: right;
`

const CloseButton = styled.img`
  width: 7%;
  vertical-align: middle;
  border: 0;
`

const ModalBody = styled.div`
  position: relative;
  display: block;
  padding: 15px;
`

const setWishlistInStorage = wl => {
  localStorage.setItem('__NOBIA__', JSON.stringify({ wishlist: wl }))
}

const restart = () => {
  setWishlistInStorage([])
  return window.location.reload()
}

const ConfirmationModal = ({ open }) => {
  if (open) {
    return (
      <Modal>
        <ModalDialog>
          <ModalContent>
            <ModalHeader>
              <CloseButton src={image} onClick={restart} />
            </ModalHeader>
            <ModalBody>
              <Container>
                <Row>
                  <Column xs={12}>
                    <SubHeadline>
                      Thank you! An email has been sent to you with your saved
                      products.
                    </SubHeadline>
                  </Column>
                </Row>
                <Row>
                  <Column xs={12}>
                    <Button kind={'primary'} size={'large'} onClick={restart}>
                      Add more products
                    </Button>
                  </Column>
                </Row>
              </Container>
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
    )
  }
  return <div />
}

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
}

export default ConfirmationModal
